module.exports = __webpack_public_path__ + "media/coin.6d5f759b.mp3";